/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roadmap_DownloadInputs */

const en_roadmap_download = /** @type {(inputs: Roadmap_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download ROADMAP.md`)
};

const de_roadmap_download = /** @type {(inputs: Roadmap_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROADMAP.md herunterladen`)
};

/**
* | output |
* | --- |
* | "Download ROADMAP.md" |
*
* @param {Roadmap_DownloadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const roadmap_download = /** @type {((inputs?: Roadmap_DownloadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roadmap_DownloadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_roadmap_download(inputs)
	return en_roadmap_download(inputs)
});